<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YGYZXj/tc-custom/9781631950001.jpg?1698088555519" alt="This image is the cover for the book Becoming a Holistic Entrepreneur"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Becoming a Holistic Entrepreneur
      </h1>
      <p class="bookDescription body article font2">
        <b>Get the confidence and tools you need to start the holistic healing business of your dreams with this inspirational business guide.</b><br/><br/>With decades of holistic business experience, author and wellness guide Grace Danielle Meek now shares the secrets to success. By following her simple yet effective Elevator Up! process, aspiring entrepreneurs will be able to get their holistic healing businesses off the ground in as little as eight weeks.<br/><br/>Meek teaches you how to set up your business simply and safely using the skills, experience, creativity, and resources you already have. In Becoming a Holistic Entrepreneur, you’ll learn how to:<br/><br/>• Design a customized and scalable Holistic Healing business plan and launch strategy<br/><br/>• Create satisfying healing results and sustainable value for your clients<br/><br/>• Develop effective financial, business, and marketing skills for growing your business and much more!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Grace Danielle Meek
      </h2>
      
      <p class="authorDescription body article"><B>Grace Danielle Meek’s</B> purpose as a Wellness Guide is to help people remember and develop who they are and why they are here in the most easeful, fun, and effective ways. After leaving the Metro DC area and corporate success in 1999, Grace’s spiritual reSourcing path connected her with extraordinary teachers and friends through Colorado, California, and New Mexico before settling on The Garden Isle, where she is fortunate to lead Inviting Balance Wellness Services.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12069698